// Copyright Epic Games, Inc. All Rights Reserved.

import React, { PropsWithChildren, ReactNode } from "react";
import { ErrorPage } from "./ErrorPage";

export type IErrorBoundaryProps = PropsWithChildren<ReactNode> & {
  errorCode: string;
  onDismiss: () => void;
};

export interface IErrorBoundaryState {
  hasError: boolean;
}

export class ErrorBoundary extends React.Component<
  IErrorBoundaryProps,
  IErrorBoundaryState
> {
  constructor(props: IErrorBoundaryProps) {
    super(props);
    this.state = {
      hasError: false,
    };
  }

  static getDerivedStateFromError(): IErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    console.error(error);
    console.error(errorInfo.componentStack);
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return (
        <ErrorPage
          errorCode={this.props.errorCode}
          onDismiss={this.props.onDismiss}
        />
      );
    }

    return this.props.children;
  }
}
